import {Injectable} from "@angular/core";
import {BaseService} from "../base.service";
import {AccumulationDataOrderRequsetType} from "../../types/request/accumulation-data-order-requset.type";
import {ACCUMULATION_DATA_ORDER, AWB_HISTORY, CANCEL_REQUEST, DATA_ORDER, DETAIL_DATA_ORDER, DOWNLOAD_ORDER, REQUEST_PICKUP} from "../../constants/endpoint.const";
import {DataOrderRequestType} from "../../types/request/data-order-request.type";
import { AwbHistoryRequestType } from "src/app/types/request/awb-histroy-request.type";
import { DownloadOrderRequsetType } from "src/app/types/request/download-order-request.type";
import { requestPickupRequestType } from "src/app/types/request/request-pickup-request.type";

@Injectable({
  providedIn: 'root',
})

export class OrderService {
  constructor(private baseService: BaseService) {
  }

  accumulationDataOrder(params: AccumulationDataOrderRequsetType) {
    return this.baseService.getData(ACCUMULATION_DATA_ORDER, params, null);
  }

  dataOrder(params: DataOrderRequestType) {
    return this.baseService.getData(DATA_ORDER, params, null);
  }
  detailDataOrder(id: number) {
    return this.baseService.getData(`${DETAIL_DATA_ORDER}/${id}`, null);
  }
  awbHistory(params: AwbHistoryRequestType) {
    return this.baseService.getData(AWB_HISTORY, params, null);
  }
  downloadOrder(params: DownloadOrderRequsetType) {
    return this.baseService.getData(DOWNLOAD_ORDER, params, null);
  }
  requestPickup(params: requestPickupRequestType) {
    return this.baseService.postData(REQUEST_PICKUP, params, null);
  }
  cancelPickup(params: {order_no: string}) {
    return this.baseService.putData(CANCEL_REQUEST, params, null);
  }
}
